import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { BaseService } from 'src/app/_services/base.service';
import { ReportsService } from 'src/app/_services/reports.service';

@Component({
  selector: 'app-partial-invoice-detail',
  templateUrl: './partial-invoice-detail.component.html',
  styleUrls: ['./partial-invoice-detail.component.scss']
})
export class PartialInvoiceDetailComponent implements OnInit {
  invoiceNumber: any = ''
  dataList: any = null
  viewMode: 'table' | 'grid' = 'table'

  constructor(
    private _bs: BaseService,
    public _reportService: ReportsService,
    private _spinner: NgxSpinnerService,
  ) { }

  ngOnInit(): void {
    //let ss = this._reportService.selectedInvoiceDetails.invoiceItems
    this.setDefaultViewMode()
    window.addEventListener('resize', () => this.setDefaultViewMode())
  }

  setDefaultViewMode() {
    // Default to grid on small screens (< 768px), table on larger screens
    this.viewMode = window.innerWidth < 768 ? 'grid' : 'table'
  }

  getInvoiceItemTitle(item: any): string {
    return String(item?.itemName ?? '').trim();
  }
}
